<template>
  <div class="modal-modify-platform">
    <el-dialog
      :title="title"
      :visible.sync="visible"
      @close="$_cancle"
      lock-scroll
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="small"
    >
      <div class="content">
        <el-form
          ref="modifyPlatform"
          :rules="rules"
          v-loading="isLoading"
          label-position="right"
          :model="formData"
          class="platform-modify__form"
        >
          <el-form-item label="运营商名称:" prop="platformName">
            <el-input
              v-model="formData.platformName"
              placeholder="必填"
              style="width: 291px"
            ></el-input>

            <div class="input-tips">
              *支持16个中文字符或32个英文字符, 允许输入/'*&^"#!$之外的特殊符号
            </div>
          </el-form-item>

          <el-form-item
            v-if="formType === 'edit' && unifiedSwitch"
            label="共享运营商ID:"
            prop="sscPlatformId"
          >
            <el-input
              v-model="formData.sscPlatformId"
              placeholder="必填"
              style="width: 291px"
            ></el-input>
            <div class="input-tips">
              切勿随便更改，修改会影响SPAS的供应商映射
            </div>
          </el-form-item>

          <el-form-item
            v-if="formType === 'edit' && unifiedSwitch"
            label="共享运营商编码:"
            class="is-required"
          >
            <el-input
              v-model="formData.sscPlatformMerchantId"
              :disabled="true"
              placeholder="必填"
              style="width: 291px"
            ></el-input>
          </el-form-item>

          <el-form-item label="组织类型:" prop="orgType">
            <el-select
              v-model="formData.orgType"
              style="width: 180px"
              placeholder="请选择状态"
            >
              <el-option label="请选择" value=""></el-option>
              <el-option label="默认组织" :value="0"></el-option>
              <el-option label="自定义组织" :value="1"></el-option>
            </el-select>
            <span class="input-tips"
              >*必填，指关联运营商的账号设置为默认或自定义组织的数据源</span
            >
          </el-form-item>

          <el-form-item label="运营商类型:">
            <el-select
              v-model="formData.platformType"
              style="width: 180px"
              placeholder="请选择状态"
            >
              <el-option label="请选择" :value="0"></el-option>
              <el-option label="餐饮" :value="1"></el-option>
              <el-option label="零售" :value="2"></el-option>
            </el-select>
            <span class="input-tips">选填</span>
          </el-form-item>

          <el-form-item label="备注:" prop="memo" type="textarea">
            <el-input
              v-model="formData.memo"
              type="textarea"
              resize="none"
              placeholder="选填"
              style="width: 366px; height: 100px"
            ></el-input>

            <div class="input-tips">*最多支持50个字符</div>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button class="save__btn" @click="$_submit">保存</el-button>
        <el-button class="cancel__btn" @click="$_cancle">取消</el-button>
      </div>
    </el-dialog>
    <merge-platform
      v-if="modal.show && modal.template === 'merge-platform'"
      :data="modal.data"
      @callback="$_callbackMergePlatform"
      @close="$_close"
    ></merge-platform>
  </div>
</template>
<script>
import * as Utils from '@/plugins/utils';
import MergePlatform from './modal-merge-platform.vue';
import { mapGetters } from 'vuex';

const validName = (rule, value, callback) => {
  if (value) {
    if (Utils.getStrLength(value) > 32) {
      callback(new Error('16个中文字符或32个英文字符'));
    } else if (value.match(/[/\'*&^"#!$]/i) != null) {
      callback(new Error(`请输入除/\'*&^"#!$之外的符号`));
    } else {
      callback();
    }
  }
  callback();
};

export default {
  name: 'modal-modify-platform',
  components: {
    MergePlatform
  },
  props: {
    title: { type: String, default: '' },
    formType: { type: String, default: 'add' },
    modalData: { type: Object, default: {} }
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      formData: {
        id: -1,
        platformName: '', // 接口名称
        orgType: '', // 组织类型
        platformType: 0,
        memo: '', // 备注
        status: 1 // 状态 1 - 启用, 2 - 停用
      },
      sameNamePlatformData: {}, // 同名运营商信息
      modal: {
        show: false,
        template: '',
        data: {}
      },
      rules: {
        platformName: [
          { required: true, message: '请输入运营商名称', trigger: 'blur' },
          { validator: validName, trigger: 'blur' }
        ],
        sscPlatformId: [
          { required: true, message: '请输入共享运营商Id', trigger: 'blur' }
        ],
        orgType: [
          { required: true, message: '请选择组织类型', trigger: 'change' }
        ],
        platformType: [
          { required: true, message: '请选择运营商类型', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (value !== '' && value == 0) {
                callback(new Error('请选择运营商类型!'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        memo: [
          {
            validator: (rule, value, callback) => {
              if (value && value.length > 50) {
                callback(new Error('最多50个字符!'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ]
      }
    };
  },
  methods: {
    $_submit() {
      this.$refs['modifyPlatform'].validate((valid) => {
        if (valid) {
          const self = this;
          if (self.formType === 'add') {
            $MessageBox.confirm({
              content: '是否确认添加运营商，结果会同步所有系统的同一个运营商',
              onOk() {
                self.saveAction();
              }
            });
          } else {
            $MessageBox.confirm({
              content: '是否确认编辑运营商，结果会同步所有系统的同一个运营商',
              onOk() {
                self.saveAction();
              }
            });
          }
        }
      });
    },

    // 保存接口逻辑方法
    async saveAction(merge = false) {
      this.isLoading = true;
      try {
        let action = this.formType === 'add' ? 'addPlatform' : 'editPlatform';
        let postData = {
          platformName: this.formData.platformName,
          orgType: this.formData.orgType,
          memo: this.formData.memo,
          status: this.formData.status,
          platformType: this.formData.platformType
        };

        // sscPlatformId：新增时取sameNamePlatformData.id, 编辑时取formData.sscPlatformId
        let sscPlatformIdMap = {
          sscPlatformId:
            this.sameNamePlatformData.id || this.formData.sscPlatformId
        };

        // 如果是新增，则传 merged 和 sscPlatformId, 如果是编辑，则传 id 和 sscPlatformId
        if (this.formType === 'add') {
          Object.assign(
            postData,
            {
              merged: merge
            },
            merge ? sscPlatformIdMap : ''
          );
        } else if (this.formType === 'edit') {
          Object.assign(
            postData,
            {
              id: this.formData.id
            },
            sscPlatformIdMap
          );
        }

        const self = this;
        await this.$service.post(action, postData).then((result) => {
          // 如果返回的状态码是30，则显示合并弹窗
          if (result.status === 30) {
            self.sameNamePlatformData = result.data;
            self.modal = {
              show: true,
              template: 'merge-platform',
              data: result.data
            };
          } else if (result.$.checkResult(result, true)) {
            // 判断是否有needConfirm字段，没有的话则正常保存，有的话则需要确认是否保存
            if (!result.data?.needConfirm) {
              $MessageBox.alert({
                content: result.msg,
                onOk() {
                  self.visible = false;
                  self.$emit('callback');
                }
              });
            } else {
              $MessageBox.confirm({
                content: result.msg,
                onOk() {
                  self.isLoading = false;
                  postData.confirmed = true;
                  self.$service.post(action, postData).then((result) => {
                    self.isLoading = false;
                    if (result.$.checkResult(result, true)) {
                      $MessageBox.alert({
                        content: result.msg,
                        onOk() {
                          self.visible = false;
                          self.$emit('callback');
                        }
                      });
                    }
                  });
                }
              });
            }
          }
        });
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },

    $_cancle() {
      this.visible = false;
      this.$emit('close');
    },
    // 合并弹窗成功回调
    $_callbackMergePlatform() {
      const handleMerge = true;
      this.$_close(handleMerge);
      this.saveAction(handleMerge);
    },
    // 关闭弹窗
    $_close(merge = false) {
      this.modal.show = false;
      this.modal.template = '';
      this.modal.data = {};
      if (!merge) {
        this.isLoading = false;
      }
    }
  },
  async created() {
    if (this.formType === 'edit') {
      this.isLoading = true;
      try {
        let result = await this.$service.post('getPlatformDetail', {
          platformKey: this.modalData.platformKey
        });
        this.formData = result.data;
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    }
  },
  mounted() {
    this.visible = true;
  },
  computed: {
    ...mapGetters({
      unifiedSwitch: 'unifiedSwitch'
    })
  }
};
</script>

<style lang="scss" scoped>
.modal-modify-platform {
  .content {
    padding: 20px 30px;
    .title {
      height: 32px;
      color: #384e8c;
      font-size: 14px;
      font-weight: 700;
    }
  }
}
.input-tips {
  margin-left: 10px;
}
</style>
